// extracted by mini-css-extract-plugin
module.exports = {"link":"PortableTextRichText_link__nYvjn","ul":"PortableTextRichText_ul__HiKwe","ol":"PortableTextRichText_ol__UL7Ey"};